module.exports = __webpack_public_path__ + "assets/img/purple-arrow-right.7170b825.png";